import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';

// Dữ liệu menu không thay đổi
const adminNavItems = [
  { type: 'link', to: '/admin/dashboard', name: 'Bảng điều khiển' },
  { type: 'header', name: 'Nội dung Website' },
  { type: 'link', to: '/admin/products-management', name: 'Sản phẩm' },
  { type: 'link', to: '/admin/news-management', name: 'Tin tức' },
  { type: 'header', name: 'Thiết bị & Bảo hành' },
  { type: 'link', to: '/admin/devices', name: 'Quản lý Loại Thiết Bị' },
  { type: 'link', to: '/admin/serials', name: 'Quản lý Mã Sê-ri (QR)' },
  { type: 'header', name: 'Khách hàng' },
  { type: 'link', to: '/admin/customers', name: 'Danh sách Liên hệ' },
  { type: 'header', name: 'Hệ thống' },
  { type: 'link', to: '/admin/accounts', name: 'Quản lý Tài khoản' },
  { type: 'link', to: '/admin/change-password', name: 'Đổi Mật khẩu' },
];

const AdminSidebar = () => {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState('');

  useEffect(() => {
    // ✅ SỬA LẠI: Đọc từ sessionStorage
    const userString = sessionStorage.getItem('user');
    if (userString) {
      try {
        const userData = JSON.parse(userString);
        setAdminName(userData.name || 'Admin');
      } catch (error) {
        console.error("Lỗi khi đọc dữ liệu người dùng:", error);
        setAdminName('Admin');
      }
    }
  }, []);

  const handleLogout = () => {
    // ✅ SỬA LẠI: Xóa khỏi sessionStorage
    sessionStorage.removeItem('user');
    // Chuyển hướng về trang đăng nhập, replace: true để không thể back lại
    navigate('/login', { replace: true });
  };

  return (
    <aside className="w-64 bg-gray-800 text-white flex flex-col h-screen fixed top-0 left-0">
      <div className="p-4 border-b border-gray-700 text-center">
        <img 
          src="/images/CTG-logo/Logo2.png" 
          alt="CTG Admin Panel" 
          className="w-40 mx-auto" 
        />
        
        {adminName && (
          <p className="text-lg text-gray-300 mt-2">
            Xin chào, <span className="font-bold">{adminName}</span>!
          </p>
        )}
      </div>
      
      <nav className="flex-grow p-4 space-y-1 overflow-y-auto">
        {adminNavItems.map((item, index) => {
          if (item.type === 'header') {
            return (
              <h2 key={index} className="px-4 pt-4 pb-2 text-xs font-bold text-gray-400 uppercase tracking-wider">
                {item.name}
              </h2>
            );
          }
          return (
            <NavLink
              key={item.to}
              to={item.to!}
              className={({ isActive }) =>
                `block w-full text-left px-4 py-2 rounded-md transition-colors duration-200 ${
                  isActive
                    ? 'bg-blue-600 text-white font-semibold'
                    : 'hover:bg-gray-700'
                }`
              }
            >
              {item.name}
            </NavLink>
          );
        })}
      </nav>

      <div className="p-4 border-t border-gray-700 space-y-4">
        <a href="/vi" target="_blank" rel="noopener noreferrer" className="block text-center w-full px-4 py-2 rounded-md bg-gray-700 hover:bg-gray-600 transition-colors">
          Xem trang web
        </a>
        <button
          onClick={handleLogout}
          className="w-full px-4 py-2 bg-red-600 text-white font-semibold rounded-md hover:bg-red-700 transition-colors"
        >
          Đăng xuất
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;